module.exports = __webpack_public_path__ + "media/images/icons/twotone/bulb-b3fa21e1773685d08b367bfcbaa255f3.svg";